module.exports = __webpack_public_path__ + "static/img/bg-pt.82e67f58.png";